import React, { useState } from "react";
import Layout from "../../Layout/Layout";
import MainContent from "./MainContent/MainContent";
import ChatsSection from "./ChatsSection/ChatsSection";
import GroupSection from "./GroupSection/GroupSection";
import CreateChannelScreen from "./CreateChannelScreen/CreateChannelScreen";
import { useLocation } from "react-router-dom";

export default function Home() {
  const [showGroupSection, setShowGroupSection] = useState(false);
  const [isNewChannel, setIsNewChannel] = useState(false);
  const location = useLocation();
  
  return (
    <Layout
      showGroupSection={showGroupSection}
      setShowGroupSection={setShowGroupSection}
      isNewChannel={isNewChannel}
      setIsNewChannel={setIsNewChannel}
    />
  );
}
